export const SET_AUTH = 'setUser';
export const PURGE_AUTH = 'logout';
export const SET_ERROR = 'setError';
export const SET_PROJECT = 'setProject';
export const FETCH_START = 'setLoading';
export const FETCH_END = 'fetchEnd';